import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';

const Page = ({ children, skipToContent }) => {
  const mainContentElement = useRef(null);

  useEffect(() => {
    if (skipToContent?.userSkipToContent) {
      scroller.scrollTo(mainContentElement.current?.id, {
        duration: 250,
        smooth: true,
        offset: -120,
      });
      mainContentElement.current?.focus();
    }
  }, [skipToContent]);

  return (
    <main
      tabIndex={0}
      id="c-page"
      className="c-page"
      role="main"
      ref={mainContentElement}
    >
      {children}
    </main>
  );
};

Page.propTypes = {
  children: PropTypes.node,
  skipToContent: PropTypes.func,
};

const mapStateToProps = state => ({
  skipToContent: state.skipToContent,
});

const ConnectedPage = connect(mapStateToProps)(Page);

Page.Main = ({ children }) => <div className="c-page__main">{children}</div>;

ConnectedPage.Main = Page.Main;

Page.Main.propTypes = {
  children: PropTypes.node,
};

export default ConnectedPage;
